import React, {Component, Fragment} from 'react';
import ProductItem from "../../components/Product/ProductItem";
import ProductItemList from "../../components/Product/ProductItemList";
import Pagination from "../../components/Pagination";
import ProductsCard from './../../components/Product/ProductsCard';



class ProductContent extends Component {
    constructor(props) {
        super(props)
    }
    
    componentDidMount() {
        
        
    }

    render() {
        // Change page

        const paginate = currentPage => {
        this.props.currentPageSetter((currentPage))};
        return (
            <div className={this.props.cols + ' ' + this.props.classes}>
                <Fragment>
                    <div className={`product-content-wrapper ${this.props.product_type === 'list' && 'product-list'}`}>
                        <div className="row mtn-30">
                            {
                                this.props.product_type === 'list' ? 
                                (
                                    <div className={'col-12'}>
                                        {
                                            this.props.productPagination.products.map(product => (
                                                <ProductItemList
                                                    key={product.id}
                                                    id={product.id}
                                                    thumb={product.thumb}
                                                    title={product.title}
                                                    excerpt={product.excerpt}
                                                    postBy={product.author.name}
                                                    date={product.publishDate}
                                                />
                                            ))
                                        }
                                    </div>
                                ) 
                                : 
                                (
                                    this.props.productPagination.products.map((product,p) => (
                                        <ProductsCard 
                                            key={product.contentItemId}
                                            id={product.contentItemId}
                                            num={p}
                                            cols={this.props.cols === 'col-12' ? 'col-md-6 col-lg-4' : 'col-md-6'}
                                            thumb={product.thumb}
                                            title={product.displayText}
                                            product={product}
                                            // excerpt={product.excerpt}
                                            // postBy={product.author.name}
                                            // date={product.publishDate}
                                        />
                                        // <ProductItem
                                        //     key={product.contentItemId}
                                        //     id={product.contentItemId}
                                        //     cols={this.props.cols === 'col-12' ? 'col-md-6 col-lg-4' : 'col-md-6'}
                                        //     thumb={product.thumb}
                                        //     title={product.displayText}
                                        //     product={product}
                                        //     // excerpt={product.excerpt}
                                        //     // postBy={product.author.name}
                                        //     // date={product.publishDate}
                                        // />
                                    ))
                                )
                            }
                        </div>
                    </div>

                    <Pagination
                        productsPerPage={this.props.productPagination.productsPerPage}
                        total={this.props.productPagination.total}
                        paginate={paginate}
                        currentPage={this.props.productPagination.currentPage}
                    />
                </Fragment>
            </div>
        );
    }
}

export default ProductContent;